let storeContent = utils.generateStore({
	ad: null,
	current_ad: 0,
	ad_interval: null,
	check_count: 0,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async submitAdViewed(ctx, ad) {
			try {
				if (ad.system_advertisement_ref) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'advertisement',
							action: 'view',
							data: {
								system_advertisement_ref:
									ad.system_advertisement_ref,
							},
						},
						'/home',
					);
				}
			} catch (err) {
				throw err;
			}
		},
		async adClickedEvent(ctx, ad) {
			try {
				if (ad.system_advertisement_ref) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'advertisement',
							action: 'click',
							data: {
								system_advertisement_ref:
									ad.system_advertisement_ref,
							},
						},
						'/home',
					);
				}
			} catch (err) {
				throw err;
			}
		},
		async productAdClicked(ctx, { ad, router }) {
			try {
				ctx.dispatch('adClickedEvent', ad);
				await $session.set('advert', ad);
				router.push({
					name: 'ViewProduct',
					params: { id: ad.product_id },
				});
			} catch (err) {
				throw err;
			}
		},
		async previousAd(ctx) {
			try {
				console.log(ctx.getters.current_ad);
				if (ctx.getters.back_ads.length > 0) {
					let num = 0;

					if (ctx.getters.current_ad > 0) {
						num = ctx.getters.current_ad - 1;
						ctx.commit('current_ad', num);
					} else {
						num = ctx.getters.back_ads.length - 1;
						ctx.commit('current_ad', num);
					}

					ctx.commit('ad', ctx.getters.back_ads[num]);
				}
			} catch (err) {
				throw err;
			}
		},
		async nextAd(ctx) {
			try {
				if (ctx.getters.back_ads.length > 0) {
					let num = 0;

					if (
						ctx.getters.current_ad <
						ctx.getters.back_ads.length - 1
					) {
						num = ctx.getters.current_ad + 1;
						ctx.commit('current_ad', num);
					} else {
						num = 0;
						ctx.commit('current_ad', num);
					}

					ctx.commit('ad', ctx.getters.back_ads[num]);
				}
			} catch (err) {
				throw err;
			}
		},
		async getDisplayAd(ctx) {
			try {
				await ctx.dispatch('fetchAd');
				clearInterval(ctx.getters.ad_interval);
				ctx.commit(
					'ad_interval',
					setInterval(async () => {
						await ctx.dispatch('fetchAd');
					}, 120000),
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchAd(ctx) {
			try {
				if (ctx.getters.back_ads.length > 0) {
					let num = Math.round(
							Math.random() * (ctx.getters.back_ads.length - 1),
						),
						ad = ctx.getters.back_ads[num];
					console.log(num);
					ctx.commit('current_ad', num);

					if (!ad) {
						ad = ctx.getters.back_ads[0];
					}

					if (ad) {
						ctx.commit('ad', ad);
						ctx.dispatch('submitAdViewed', ad);
					}
				} else {
					if (ctx.getters.check_count === 0) {
						// Try fetching ads if ads returned are empty
						ctx.commit('check_count', 1);
						ctx.commit(
							'back_ads',
							await utils.fetchAdvertisements(),
						);
						await ctx.dispatch('getDisplayAd');
					}
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchSponsoredAds(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'sponsored_ads',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('ads', res.result);
			} catch (err) {
				throw err;
			}
		},
	},
};
